import { gql, useFragment } from "@apollo/client";

// Constants
import { linkFields } from "@/constants/gql-fields";

// Styling
import style from "./footer--privacy-policy.module.scss";

// Components
import Link from "next/link";

export default function PrivacyPolicy({ entry }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: PrivacyPolicy.fragments.entry,
    fragmentName: "PrivacyPolicyFragment",
    from: {
      __typename: entry.__typename,
      id: entry.id,
    },
  });
  if (!complete) {
    return;
  }

  // Variables
  const privacyLinks = data.footerContent.privacyPolicyLinks;

  // Return if No Links
  if (privacyLinks === null) return;

  // Return Links
  return (
    <div className={`${style.privacyPolicy}`}>
      {privacyLinks.map((linkItem, index) => {
        return (
          <Link
            href={linkItem.link.url}
            target={linkItem.link.target}
            key={index}
          >
            {linkItem.link.title}
          </Link>
        );
      })}
    </div>
  );
}

PrivacyPolicy.fragments = {
  entry: gql`
    fragment PrivacyPolicyFragment on GeneralSettingsACF {
      id
      __typename
      footerContent {
        privacyPolicyLinks {
          link {
            ${linkFields}
          }
        }
      }
    }
  `,
};
